import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { DOCUMENT_CENTER } from "./actionTypes";

const INIT_STATE = {
    listaDocumentCenter: {
        totalRecords: 0,
        records: [],
    },
    loadingDocumentCenter: true,
    filterDocumentCenter: null,
    messageDocumentCenter: null,
    cleanMessageDocumentCenter: null,
    pageSizeDocumentCenter: DEFAULT_PAGE_SIZE,
    
    documentCenterDownload: null,
    errorDocumentCenterDownload: null,

    documentCenterProducts: null,
    loadingDocumentCenterProducts: true,
    errorDocumentCenterProducts: null,
}

const DocumentCenterReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case DOCUMENT_CENTER.GET_LIST.REQUEST: {
            return {
                ...state,
                loadingDocumentCenter: true,
            };
        }
        case DOCUMENT_CENTER.GET_LIST.SUCCESS: {
            return {
                ...state,
                listaDocumentCenter: action.payload,
                loadingDocumentCenter: false,
            };
        }
        case DOCUMENT_CENTER.GET_LIST.FAIL: {
            return {
                ...state,
                messageDocumentCenter: action.payload,
                loadingDocumentCenter: false,
            };
        }

        case DOCUMENT_CENTER.GET_DOCUMENT_CENTER_PRODUCTS.REQUEST: {
            return {
                ...state,
                loadingDocumentCenterProducts: true,
            };
        }
        case DOCUMENT_CENTER.GET_DOCUMENT_CENTER_PRODUCTS.SUCCESS: {
            return {
                ...state,
                documentCenterProducts: action.payload,
                loadingDocumentCenterProducts: false,
            };
        }
        case DOCUMENT_CENTER.GET_DOCUMENT_CENTER_PRODUCTS.FAIL: {
            return {
                ...state,
                errorDocumentCenterProducts: action.payload,
                loadingDocumentCenterProducts: false,
            };
        }

        case DOCUMENT_CENTER.GET_DOWNLOAD_DOCUMENT_CENTER.REQUEST: {
            return {
                ...state,
                loadingDocumentCenter: true,
            };
        }
        case DOCUMENT_CENTER.GET_DOWNLOAD_DOCUMENT_CENTER.SUCCESS: {
            return {
                ...state,
                documentCenterDownload: action.payload,
                loadingDocumentCenter: false,
            };
        }
        case DOCUMENT_CENTER.GET_DOWNLOAD_DOCUMENT_CENTER.FAIL: {
            return {
                ...state,
                errorDocumentCenterDownload: action.payload,
                loadingDocumentCenter: false,
            };
        }

        case DOCUMENT_CENTER.LOAD_EMPTY: {
            return {
                ...state,
                documentCenterDownload: null,
                errorDocumentCenterDownload: null,
            }
        }

        default:
            return state;
    }
};

export default DocumentCenterReducer;